import ImageWithBasePath from "@/components/image-with-base-path";
import type { LightboxSlide } from "@/components/common-lightbox/Lightbox";
import Lightbox from "@/components/common-lightbox/Lightbox";
import { useState } from "react";
import { Link } from "react-router";
import Slider, { type Settings } from "react-slick";
import videoSrc from "../../../../../public/assets/img/video/video-02.mp4";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const AboutSection = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const slides: LightboxSlide[] = [
    {
      type: "video",
      src: videoSrc,
      alt: "About Video",
    },
  ];

  const settings: Settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {/* About Section */}
      <section className="about-section-fourteen section pb-0">
        <div className="container">
          {/* start row */}
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="about-img-fourteen">
                <div className="about-img-01">
                  <ImageWithBasePath
                    src="assets/img/about/about-06.jpg"
                    alt="about"
                    className="img-fluid"
                  />
                </div>
                <div className="about-img-02">
                  <ImageWithBasePath
                    src="assets/img/about/about-07.jpg"
                    alt="about"
                    className="img-fluid"
                  />
                </div>
                <div className="exp-item">
                  <p className="num mb-0">15+</p>
                  <p className="mb-0">
                    Years of <span>Experience</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="about-content-fourteen">
                <div
                  className="section-header section-header-fourteen wow fadeInUp"
                  data-wow-duration="1s"
                >
                  <h2 className="section-title">
                    <span className="section-line">Trusted</span> Expertise,{" "}
                    <span className="subtitle">Personal Care</span>
                  </h2>
                  <p className="mb-0">
                    Your skin deserves expert care, compassion, and confidence.
                    At our dermatology clinic, we are dedicated to providing
                    advanced, personalized skin, hair, and nail treatments for
                    patients.
                  </p>
                </div>
                <div className="about-wrap">
                  <ul className="about-lists">
                    <li>
                      <p>Experienced Dermatology Specialists</p>
                    </li>
                    <li>
                      <p>Modern Technology &amp; Advanced Treatments</p>
                    </li>
                    <li>
                      <p>Personalized Skin Care Plans</p>
                    </li>
                    <li>
                      <p>Safe &amp; Comfortable Environment</p>
                    </li>
                    <li>
                      <p>Transparent &amp; Ethical Care</p>
                    </li>
                  </ul>
                  <div className="abt-video">
                    <ImageWithBasePath
                      src="assets/img/about/video-02.jpg"
                      alt="video"
                      className="img-fluid"
                    />
                    <Link
                      to="#"
                      className="video-icon"
                      aria-label="video"
                      data-fancybox=""
                      onClick={() => {
                        setCurrentIndex(0);
                        setLightboxOpen(true);
                      }}
                    >
                      <i className="isax isax-arrow-right-41" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end row */}
        </div>
        <div className="company-slider-fourteen section-top">
          <Slider {...settings}>
            <div className="slide-item">
              <ImageWithBasePath
                src="assets/img/company/company-skin-01.svg"
                alt="client logo"
              />
            </div>
            <div className="slide-item">
              <ImageWithBasePath
                src="assets/img/company/company-skin-02.svg"
                alt="client logo"
              />
            </div>
            <div className="slide-item">
              <ImageWithBasePath
                src="assets/img/company/company-skin-03.svg"
                alt="client logo"
              />
            </div>
            <div className="slide-item">
              <ImageWithBasePath
                src="assets/img/company/company-skin-04.svg"
                alt="client logo"
              />
            </div>
            <div className="slide-item">
              <ImageWithBasePath
                src="assets/img/company/company-skin-05.svg"
                alt="client logo"
              />
            </div>
            <div className="slide-item">
              <ImageWithBasePath
                src="assets/img/company/company-skin-06.svg"
                alt="client logo"
              />
            </div>
            <div className="slide-item">
              <ImageWithBasePath
                src="assets/img/company/company-skin-03.svg"
                alt="client logo"
              />
            </div>
          </Slider>
        </div>
      </section>
      {/* About Section End */}
      <Lightbox
        images={slides}
        currentIndex={currentIndex}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        onNavigate={(index) => setCurrentIndex(index)}
      />
    </>
  );
};

export default AboutSection;
